export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export interface RequestConfig extends RequestInit {
  headers?: HeadersInit;
}

export interface ErrorResponse {
  message: string;
  data: object;
}

export async function fetchData<T>(
  apiUrl: string,
  _url: string = '',
  method: HttpMethod = 'GET',
  body: unknown = null,
  config: RequestConfig = {},
): Promise<T | null> {
  if (!apiUrl) throw new Error('API URL is required');
  let url = `${apiUrl}/v1/${_url}`;
  if (_url.includes('https://')) url = _url;
  const requestConfig: RequestConfig = {
    ...config,
    method: method,
    headers: {
      'Content-Type': 'application/json',
      ...config.headers,
    },
  };

  if (body && method !== 'GET') {
    requestConfig.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, requestConfig);
    const resJSON = await response.json()
    if (!response.ok) {
      const errorData = resJSON as ErrorResponse;
      throw `${response.status} ${response.statusText}: ${errorData.message}`;
    }
    return resJSON as T;
  } catch (error) {
    console.error(`Fetch error: ${JSON.stringify({
      url,
      method,
      error,
      requestConfig,
    })}`);
    throw error;
  }
}
